<template>
    <div v-if="updateExists"
        aria-live="polite" aria-atomic="true" class="fixed-bottom d-flex justify-content-center align-items-center">
        <div class="alert alert-warning" role="alert">
            <h5 class="alert-heading"><i class="fa fa-exclamation-triangle mr-3" aria-hidden="true"></i>{{ $t('versionChangeMsg') }}
                <button type="button" class="btn btn-link btn-lg text-danger m-0 p-0" @click.stop="refreshApp">
                    тук.
                </button>
            </h5>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServiceWorkerNotifier',
    data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },
  created() {
    this.swUpdated();
  },
  methods: {
    swUpdated() {
      // Listen for our custom event from the SW registration
      document.addEventListener('swUpdated', this.updateAvailable, { once: true });

      // Prevent multiple refreshes
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        // Here the actual reload of the page occurs
        window.location.reload();
      });
    },
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
    },
    refreshApp() {
      this.updateExists = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return;
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  }
};
</script>
